export default __webpack_public_path__ + "media/images/svg/slider-arrow-icon-da75a8d1ce00983117284e3ae717ceba.svg";